import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { Page } from '@/components/layout/Page';
import { PageContent } from '@/components/layout/PageContent';
import { GlobalRankingTab } from '@/components/ranking/GlobalRankingTab';
import { ByRaceRankingTab } from '@/components/ranking/ByRaceRankingTab';

type Tab = 'global' | 'byRace';

export function RankingPage() {
    const { t } = useTranslation('bets');
    const [activeTab, setActiveTab] = useState<Tab>('global');

    return (
        <Page className="bg-slate-50">
            <PageContent width="standard" className="space-y-6 pb-24">
                <div className="flex items-center justify-between gap-4">
                    <h1 className="text-2xl font-black text-slate-900">{t('ranking.title')}</h1>

                    <div className="flex gap-1.5 flex-shrink-0">
                        {(['global', 'byRace'] as const).map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={cn(
                                    "px-3 py-1.5 rounded-lg text-xs sm:text-sm font-bold transition-all",
                                    activeTab === tab
                                        ? "bg-emerald-600 text-white shadow-sm"
                                        : "bg-white text-slate-500 border border-slate-100 hover:bg-slate-50"
                                )}
                            >
                                {t(`ranking.tabs.${tab}`)}
                            </button>
                        ))}
                    </div>
                </div>

                {activeTab === 'global' && <GlobalRankingTab />}
                {activeTab === 'byRace' && <ByRaceRankingTab />}
            </PageContent>
        </Page>
    );
}
